import EmptyChart from './EmptyChart';

export default EmptyChart;
